<div class="card padding-card t-align-l no-radius border">
    <form (ngSubmit)="submit()">
        <div class="card-body">
            <div class="gallery-header mb-4">
                <div class="header-content">
                    <h5 class="card-title mb-2">Project Gallery & Videos</h5>
                    <div class="upload-counter">
                        <span class="count" [ngClass]="{'uploaded': canSubmit(), 'insufficient': !canSubmit()}">
                            {{ getUploadedCount() }}/{{ minUploads }}-{{ maxUploads }}
                        </span>
                        <span class="status-text" *ngIf="canSubmit()" class="text-success">✓ Ready to submit</span>
                        <span class="status-text" *ngIf="!canSubmit()" class="text-danger">Need at least {{ minUploads }} uploads</span>
                    </div>
                </div>
            </div>
            <p class="text-muted mb-4">
                <small>Upload 5-20 images/videos (min 800x550px for images). Drag & drop or click to upload. Supported: JPG, PNG, MP4, WebM</small>
            </p>
            <!-- Main Upload Zone -->
            <div class="main-upload-zone" 
                 [ngClass]="{'drag-over': dragOverIndex === -1}"
                 (dragover)="onDragOver($event, -1)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onDrop($event, -1)"
                 (click)="openFileDialog()">
                
                <div class="fu-text">
                    <div class="upload-icon">
                        <i class="ri-cloud-upload-line"></i>
                    </div>
                    <span class="upload-text">
                        Click here or drag & drop<br>
                        <small>Images or Videos (up to 20 files)</small>
                    </span>
                    <button type="button" class="btn btn-sm btn-primary mt-3" (click)="openFileDialog()">
                        <i class="ri-add-line"></i> Browse Files
                    </button>
                </div>
                
                <!-- Drag Over Text -->
                <div class="drag-over-text" *ngIf="dragOverIndex === -1">
                    <i class="ri-check-double-line"></i> Drop files here
                </div>
                
                <input #mediaFileInput
                       class="upload" 
                       type="file" 
                       id="mediaInput" 
                       name="mediaInput" 
                       [accept]="allFormats"
                       (change)="onFileSelected($event, -1)"
                       multiple>
            </div>

            <!-- Uploaded Media List -->
            <div class="uploaded-media-section" *ngIf="getUploadedCount() > 0">
                <h6 class="mt-4 mb-3">Uploaded Media ({{ getUploadedCount() }})</h6>
                <div class="media-grid">
                    <ng-container *ngFor="let media of propertyMedia; let idx = index;">
                        <div class="media-item" *ngIf="media.url">
                            <!-- Image Thumbnail -->
                            <div class="media-thumbnail" *ngIf="media.type === 'image'">
                                <img [src]="media.url" alt="Thumbnail">
                            </div>
                            
                            <!-- Video Thumbnail -->
                            <div class="media-thumbnail video" *ngIf="media.type === 'video'">
                                <video [src]="media.url"></video>
                                <span class="video-badge"><i class="ri-play-circle-fill"></i></span>
                            </div>
                            
                            <!-- Remove Button -->
                            <button type="button" class="remove-btn" (click)="removeMedia(idx)" title="Remove">
                                <i class="ri-delete-bin-line"></i>
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        
        <div class="card-footer bg-light p-3">
            <button type="submit" 
                    class="btn btn-primary btn-lg mb-2 float-right mr-2"
                    [disabled]="!canSubmit()">
                Next ({{ getUploadedCount() }}/{{ minUploads }})
            </button>
            <button type="button" (click)="back()" class="btn btn-secondary btn-lg mb-2 float-right mr-2">Back</button>
        </div>
    </form>
</div>